export default __webpack_public_path__ + "static/media/robot_hand.445ccaa1.jpg";